import { ChevronDown } from 'lucide-react';

// A stable component identity keeps controls, focus and scroll intact on edits.
export const InstrumentPolicySection = ({ id, title, children, expandedSections, enabledSections, onToggle, onToggleEnabled }) => {
  const expanded = expandedSections[id];
  const slug = id.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
  const panelId = `instrument-policy-panel-${slug}`;
  return <section className="instrument-policy-section">
    <div className="instrument-policy-section-header">
      <input type="checkbox" checked={enabledSections[id]} aria-label={`${title} politikasını seç`}
        data-testid={`policy-enable-${id}`} onChange={() => onToggleEnabled(id)} />
      <button type="button" data-testid={`policy-section-${id}`} aria-expanded={expanded}
        aria-controls={panelId} onClick={() => onToggle(id)}>
        <span>{title}</span>
        <ChevronDown size={16} aria-hidden="true" className={expanded ? 'is-expanded' : ''} />
      </button>
    </div>
    <div id={panelId} data-testid={panelId} className="instrument-policy-section-body" hidden={!expanded}
      onChangeCapture={() => { if (!enabledSections[id]) onToggleEnabled(id); }}>
      {children}
    </div>
  </section>;
};